import dayjs from 'dayjs';
import CardContent from 'components/Base/Layout/Content/CardContent';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import { TPartsUI } from 'data/types/events.types';
import { formatStringToTitleCase } from 'helpers/utils';
import { TabBodyWrapper } from 'components/Base/Tabs';
import AttendanceList from './AttendanceList';
import { TAttendanceListTabProps } from './AttendanceTab.types';

const AttendanceTab = ({ data }: TAttendanceListTabProps) => {
  const sessions = data?.parts || [];

  const combineDateAndTime = (dateValue?: string, startTime?: string) => {
    if (!dateValue || !startTime) {
      return '';
    }

    // Parse the date string
    const date = dayjs(dateValue);

    // Parse the time in HH:mm:ss format
    const time = dayjs(startTime, 'HH:mm:ss');

    // Combine date with the new time and format it like the original
    return date
      .hour(time.hour())
      .minute(time.minute())
      .second(time.second())
      .millisecond(0)
      .format('MMM D, YYYY h:mm A'); // This will give you "Aug 30, 2025 10:00 AM"
  };

  const renderAttendance = (session: TPartsUI) => {
    const dateTime = combineDateAndTime(session.date?.value, session.startTime);

    return (
      <div key={session.partType}>
        <CardContent tabContent contentPadding="8px 0px">
          <AttendanceList
            title={`${formatStringToTitleCase(session.partType)} - ${
              dateTime || ''
            }`}
            sessionDateTime={dateTime}
            eventId={data?.id || ''}
            eventStatus={data?.status}
            eventType={data?.type}
            customQuestion={data?.customQuestion.value}
            csvFileNamePrefix={data?.location?.name || data?.host?.name}
            hideChildInfo={!!data?.isCCP}
            partType={session.partType}
            sessions={sessions}
          />
        </CardContent>
      </div>
    );
  };

  const items: TabsProps['items'] = (sessions || []).map((session, index) => {
    const dateTime = combineDateAndTime(session.date?.value, session.startTime);
    return {
      key: index.toString(),
      label: `${formatStringToTitleCase(session.partType)} • ${dateTime || ''}`,
      children: renderAttendance(session),
    };
  });

  if (!data) return null;

  return (
    <TabBodyWrapper isEmpty={!items.length} emptyText="No Attendance data yet.">
      <Tabs
        defaultActiveKey="0"
        items={items}
        tabBarStyle={{ margin: '-16px -16px 0 -16px' }}
      />
    </TabBodyWrapper>
  );
};

export default AttendanceTab;
